<template>
    <div class="poi-write-review content-box pb-5" id="writeReview">
        <div class="line line-left" v-if="!editMode">
            <div class="h2-like bg-main-darker">Donnez votre avis, <br>cumulez des points</div>
        </div>

        <div v-if="errors.description" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p v-for="error of this.errors.description" class="lh-sm mb-0">{{ error }}</p>
        </div>

        <div v-if="errors.note1" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p v-for="error of this.errors.note1" class="lh-sm mb-0">{{ error }}</p>
        </div>

        <div v-if="errors.note2" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p v-for="error of this.errors.note2" class="lh-sm mb-0">{{ error }}</p>
        </div>

        <div v-if="errors.note3" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p v-for="error of this.errors.note3" class="lh-sm mb-0">{{ error }}</p>
        </div>

        <div v-if="errors.note4" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p v-for="error of this.errors.note4" class="lh-sm mb-0">{{ error }}</p>
        </div>

        <div v-if="errors.doubleReview" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p class="lh-sm mb-0">{{ errors.doubleReview }}</p>
        </div>

        <div v-if="errors.validateReview" class="bg-darkRed text-white mb-3 mt-2 p-2">
            <p class="lh-sm mb-0">{{ errors.validateReview }}</p>
        </div>

        <div v-if="!editMode">
            <button class="btn" :class=" guided ? 'btn-red' : 'btn-grey' " id="guidedReview" @click.prevent="guided = true">Guidé</button>
            <button class="btn" :class=" !guided ? 'btn-red' : 'btn-grey' " id="freeReview" @click.prevent="guided = false" @click="updateReview">Libre</button>
        </div>

        <form class="row guided" id="guided" v-if="guided" @submit.prevent="prepareData()">
            <p class="col-12 fs-5 fw-light mt-3">1- Cliquez sur les étoiles et commentez</p>

            <div class="col-6 mt-3">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <label for="criteria1" class="fs-5 mb-0">{{ this.criterion1Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>

                <textarea name="criteria1" id="criteria1" class="form-control review-textarea lh-sm" rows="3" placeholder="Décrivez l'accueil et les conseils du personnel..." v-model="criteria1" @keyup="updateCount('Guided')"></textarea>
            </div>

            <div class="col-6 mt-3">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <label for="criteria2" class="fs-5 mb-0">{{ this.criterion2Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>

                <textarea name="criteria2" id="criteria2" class="form-control review-textarea lh-sm" rows="3" placeholder="Décrivez le cadre et la propreté du lieu..." v-model="criteria2" @keyup="updateCount('Guided')"></textarea>
            </div>

            <div class="col-6 mt-3">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <label for="criteria3" class="fs-5 mb-0">{{ this.criterion3Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>

                <textarea name="criteria3" id="criteria3" class="form-control review-textarea lh-sm" rows="3" placeholder="Décrivez la qualité des plats servis..." v-model="criteria3" @keyup="updateCount('Guided')"></textarea>
            </div>

            <div class="col-6 mt-3">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <label for="criteria4" class="fs-5 mb-0">{{ this.criterion4Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>

                <textarea name="criteria4" id="criteria4" class="form-control review-textarea lh-sm" rows="3" placeholder="Décrivez votre sentiment lié au rapport qualité-prix..." v-model="criteria4" @keyup="updateCount('Guided')"></textarea>
            </div>

            <div class="col-12 mt-4">
                <a href="#hidden-text" data-bs-toggle="collapse" aria-expanded="false" role="button" aria-controls="hidden-text" id="completeReview">Complétez votre avis (facultatif)</a>
                <div id="hidden-text" class="collapse flex-column">
                    <label class="fs-5 fw-light mb-2" for="criteria5">2- Complétez votre avis (facultatif)</label>

                    <textarea name="criteria5"
                              id="criteria5"
                              class="form-control review-textarea lh-sm"
                              rows="5"
                              placeholder="Complétez votre avis si vous avez quelque chose à ajouter"
                              v-model="criteria5"
                              @keyup="updateCount('Guided')"></textarea>
                </div>
            </div>

            <div class="col-12 mt-4">
                <label for="guided-review-date" class="mb-2">Date de l'expérience :</label>
                <input type="date" name="guided-review-date" class="form-control mb-4" v-model="date" id="guided-review-date">

                <p class="small-text fst-italic">{{ countGuided }} {{ countGuided > 1 ? 'caractères' : 'caractère' }} {{ messageGuided }}</p>
                <p class="small-text lh-sm fst-italic">
                    En validant, je certifie sur l'honneur avoir visité
                    récemment cette adresse et que cet avis reflète ma propre expérience et mon opinion
                    authentique. Je comprends que Justacoté applique une politique de tolérance zéro sur les
                    faux avis.
                </p>

                <a class="btn btn-red text-white text-decoration-none px-5" data-bs-toggle="modal" data-bs-target="#previewModal" id="previewModalButton">Prévisualiser votre avis</a>
                <button v-if="review_data.user_id !== 0" class="btn btn-red ps-5 pe-3">Valider<i class="fas fa-caret-right text-white ms-4"></i></button>
                <a v-if="review_data.user_id === 0" class="btn btn-red px-5 text-white" data-bs-toggle="modal" data-bs-target="#connexion" @click="prepareData(true)">Valider</a>
            </div>
        </form>

        <div v-if="!editMode" class="modal fade add-to-books-modal" id="previewModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content modal-block">
                    <div class="modal-close-button box-shadow">
                        <button type="button" class="btn-close btn-close-white p-2" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body modal-block-content mx-auto box-shadow position-relative px-5 py-3">
                        <div class="line line-left">
                            <div class="h2-like bg-white-like">Voici à quoi va ressembler votre avis une fois publié :</div>
                        </div>

                        <div id="reviewPreviewContent" class="lh-sm">
                            <p>{{ criteria1 }}</p>
                            <p>{{ criteria2 }}</p>
                            <p>{{ criteria3 }}</p>
                            <p>{{ criteria4 }}</p>
                            <p>{{ criteria5 }}</p>
                        </div>

                        <button class="d-block ms-auto btn btn-red px-5" data-bs-dismiss="modal">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <form class="row free" id="free" v-if="!guided" @submit.prevent="prepareData()">
            <div class="col-12">
                <h3><label class="fs-5 fw-light mt-3 mb-2" for="free_text">1- {{ editMode ? 'Modifiez votre avis :' : 'Écrivez un avis' }}</label></h3>

                <textarea name="free_text"
                          id="free_text"
                          class="form-control review-textarea lh-sm"
                          rows="10"
                          placeholder="Écrivez votre avis"
                          v-model="fullReview"
                          @keyup="updateCount('Free')"></textarea>

                <p class="small-text fst-italic">{{ countFree }} {{ countFree > 1 ? 'caractères' : 'caractère' }} {{ messageFree }}</p>

                <h3 class=" col-12 fs-5 fw-light mt-4">2- {{ editMode ? 'Cliquez sur les étoiles pour modifier votre note' : 'Cliquez sur les étoiles pour attribuer votre note' }}</h3>
            </div>

            <div class="col-6 mt-2">
                <div class="d-flex align-items-center justify-content-between mb-3 px-3">
                    <label for="criteria1" class="fs-5 mb-0">{{ this.criterion1Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria1')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria1Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between mb-3 px-3">
                    <label for="criteria2" class="fs-5 mb-0">{{ this.criterion2Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria2')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria2Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-6 mt-3">
                <div class="d-flex align-items-center justify-content-between mb-3 px-3">
                    <label for="criteria3" class="fs-5 mb-0">{{ this.criterion3Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria3')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria3Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between mb-3 px-3">
                    <label for="criteria4" class="fs-5 mb-0">{{ this.criterion4Label }}</label>

                    <div class="d-flex justify-content-end">
                        <button class="bg-transparent border-0 m-0 p-0 " value="1" type="button" @click.prevent="setMark(1, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 1 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="2" type="button" @click.prevent="setMark(2, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 2 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="3" type="button" @click.prevent="setMark(3, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 3 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="4" type="button" @click.prevent="setMark(4, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark >= 4 ? 'marked' : 'unmarked' ">
                        </button>

                        <button class="bg-transparent border-0 m-0 p-0 " value="5" type="button" @click.prevent="setMark(5, 'criteria4')">
                            <img src="/images/pois/big-star-full.png" alt="" class="write-review-star" :class=" criteria4Mark === 5 ? 'marked' : 'unmarked' ">
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-12 mt-4">
                <h3><label for="free-review-date" class=" col-12 fs-5 fw-light mb-2">3- Date de l'expérience :</label></h3>
                <input type="date" name="free-review-date" class="form-control mb-4" v-model="date" id="free-review-date">

                <p class="small-text lh-sm fst-italic">
                    En validant, je certifie sur l'honneur avoir visité
                    récemment cette adresse et que cet avis reflète ma propre expérience et mon opinion
                    authentique. Je comprends que Justacoté applique une politique de tolérance zéro sur les
                    faux avis.
                </p>

                <button v-if="review_data.user_id !== 0" class="btn btn-red px-5" type="submit">Valider</button>
                <a v-if="review_data.user_id === 0" class="btn btn-red px-5 text-white" data-bs-toggle="modal" data-bs-target="#connexion" @click="prepareData(true)">Valider</a>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    props: {
        review: String,
        subcategory: Object,
        poiId: String,
        userId: String,
    },

    data() {
        return {
            criteria1: '',
            criteria1Mark: null,
            criteria2: '',
            criteria2Mark: null,
            criteria3: '',
            criteria3Mark: null,
            criteria4: '',
            criteria4Mark: null,
            criteria5: '',
            countFree: 0,
            countGuided: 0,
            criterion1Label: null,
            criterion2Label: null,
            criterion3Label: null,
            criterion4Label: null,
            date: null,
            editMode: false,
            errors: {
                description: null,
                doubleReview: null,
                note1: null,
                note2: null,
                note3: null,
                note4: null,
                validateReview: null,
            },
            fullReview: '',
            guided: true,
            messageFree: '(100 caractères minimum)',
            messageGuided: '(100 caractères minimum)',
            review_data: {
                description: null,
                experience_date: null,
                id: null,
                note1: null,
                note2: null,
                note3: null,
                note4: null,
                poi_id: null,
                user_id: null,
            },
        }
    },

    beforeMount() {
        if (this.review) {
            this.editMode = true
            this.guided = false

            const data = JSON.parse(this.review)
            this.fullReview = data.description
            this.date = data.experience_date
            this.review_data.id = data.id
            this.criteria1Mark = data.note1
            this.criteria2Mark = data.note2
            this.criteria3Mark = data.note3
            this.criteria4Mark = data.note4
            this.review_data.poi_id = data.poi_id
            this.review_data.user_id = data.user_id
        }
    },

    mounted() {
        if (this.poiId) {
            this.review_data.poi_id = parseInt(this.poiId)
        }
        if (this.userId) {
            this.review_data.user_id = parseInt(this.userId)
        }

        this.criterion1Label = this.subcategory.label1;
        this.criterion2Label = this.subcategory.label2;
        this.criterion3Label = this.subcategory.label3;
        this.criterion4Label = this.subcategory.label4;

        let reviewInSession = JSON.parse(sessionStorage.getItem('review'))

        if (reviewInSession !== null && reviewInSession.review_data.poi_id === parseInt(this.poiId)) {
            this.retrieveSession(reviewInSession)

            if (parseInt(this.userId)) {
                this.errors.validateReview = 'Vous êtes maintenant connecté sur Justacoté, vous pouvez à présent valider votre avis.'
            }

            window.location.href = '#writeReview'

        }

        this.updateCount('Free');
    },

    methods: {
        setMark(mark, section) {
            this[section + 'Mark'] = mark
        },

        prepareData(session = false) {
            this.review_data.note1 = this.criteria1Mark
            this.review_data.note2 = this.criteria2Mark
            this.review_data.note3 = this.criteria3Mark
            this.review_data.note4 = this.criteria4Mark
            this.review_data.experience_date = this.date

            if (session) {
                let data = {
                    review_data: this.review_data,
                    guided: this.guided,
                }

                if (this.guided) {
                    data.criteria1 = this.criteria1
                    data.criteria2 = this.criteria2
                    data.criteria3 = this.criteria3
                    data.criteria4 = this.criteria4
                    data.criteria5 = this.criteria5
                }

                if (!this.guided) {
                    data.fullReview = this.fullReview
                }

                this.saveToSession(data)

            } else {
                if (this.guided) {
                    this.review_data.description = this.criteria1 + '\n ' + this.criteria2 + '\n ' + this.criteria3 + '\n ' + this.criteria4 + '\n ' + this.criteria5
                }

                if (!this.guided) {
                    this.review_data.description = this.fullReview
                }

                if (this.editMode) {
                    this.submitEdit()
                } else {
                    this.submitCreate()
                }
            }
        },

        saveToSession(data) {
            let reviewInSession = sessionStorage.getItem('review')

            if (reviewInSession !== null) {
                sessionStorage.removeItem('review')
            }

            sessionStorage.setItem('review', JSON.stringify(data))
        },

        deleteSession() {
            let reviewInSession = sessionStorage.getItem('review')

            if (reviewInSession !== null) {
                sessionStorage.removeItem('review')
            }
        },

        retrieveSession(reviewInSession) {
            if (reviewInSession.guided) {
                this.criteria1 = reviewInSession.criteria1
                this.criteria2 = reviewInSession.criteria2
                this.criteria3 = reviewInSession.criteria3
                this.criteria4 = reviewInSession.criteria4

            } else {
                this.fullReview = reviewInSession.fullReview
            }

            this.setMark(reviewInSession.review_data.note1, 'criteria1')
            this.setMark(reviewInSession.review_data.note2, 'criteria2')
            this.setMark(reviewInSession.review_data.note3, 'criteria3')
            this.setMark(reviewInSession.review_data.note4, 'criteria4')

            this.guided = reviewInSession.guided

            this.date = reviewInSession.review_data.experience_date
        },

        submitCreate() {
            axios
                .post('/reviews/store', this.review_data)
                .then((response) => {
                    if (response.data.doubleReview) {
                        this.errors.doubleReview = response.data.doubleReview
                        window.location.href = window.location.origin + window.location.pathname + '#writeReview'
                    } else {
                        window.location.href = window.location.origin + window.location.pathname
                        this.deleteSession()
                    }
                })
                .catch((error) => {
                    console.log(error)
                    let errors = error.response.data.errors

                    this.errors = {
                        description: null,
                        doubleReview: null,
                        note1: null,
                        note2: null,
                        note3: null,
                        note4: null,
                    }

                    if (errors) {
                        for (const [error_item_key, error_item] of Object.entries(errors)) {
                            this.errors[error_item_key] = error_item
                        }
                    }
                    window.location.href = window.location.origin + window.location.pathname + '#writeReview'
                })
        },

        submitEdit() {
            axios
                .patch('/reviews/update', this.review_data)
                .then((response) => {
                    this.redirectUrl = route('reviews.edit', this.review_data.id) + '/1'
                    window.location.href = this.redirectUrl;
                })
                .catch((error) => {
                    let errors = error.response.data.errors
                    for (const [error_item_key, error_item] of Object.entries(errors)) {
                        this.errors[error_item_key] = error_item
                    }
                    window.location.href = route('reviews.edit', this.review_data.id);
                })
        },

        updateCount(reviewType) {
            if (reviewType === 'Guided') {
                this.countGuided = this.criteria1.length + this.criteria2.length + this.criteria3.length + this.criteria4.length + this.criteria5.length
            } else if (reviewType === 'Free') {
                this.countFree = this.fullReview ? this.fullReview.length : 0
            }

            if (this['count' + reviewType] >= 0 && this['count' + reviewType] < 75) {
                this['message' + reviewType] = '(100 caractères minimum)'
            } else if (this['count' + reviewType] >= 75 && this['count' + reviewType] < 100) {
                this['message' + reviewType] = '(Encore un effort, on y est presque !)'
            } else if (this['count' + reviewType] >= 100 && this['count' + reviewType] < 200) {
                this['message' + reviewType] = '(Félicitation, on continue ? À 300 caractères, vous gagnez 10 points bonus !)'
            } else if (this['count' + reviewType] >= 100 && this['count' + reviewType] < 200) {
                this['message' + reviewType] = '(Félicitation, on continue ? À 300 caractères, vous gagnez 10 points bonus !)'
            } else if (this['count' + reviewType] >= 200 && this['count' + reviewType] < 300) {
                this['message' + reviewType] = '(Vous êtes un véritable rédacteur !)'
            } else if (this['count' + reviewType] >= 300) {
                this['message' + reviewType] = '(20 points !)'
            }
        },

        updateReview() {
            if (this.criteria1 && !this.fullReview.includes(this.criteria1)) {
                this.fullReview = this.fullReview.concat(this.criteria1 + '\n')
            }

            if (this.criteria2 && !this.fullReview.includes(this.criteria2)) {
                this.fullReview = this.fullReview.concat(this.criteria2 + '\n')
            }

            if (this.criteria3 && !this.fullReview.includes(this.criteria3)) {
                this.fullReview = this.fullReview.concat(this.criteria3 + '\n')
            }

            if (this.criteria4 && !this.fullReview.includes(this.criteria4)) {
                this.fullReview = this.fullReview.concat(this.criteria4 + '\n')
            }

            if (this.criteria5 && !this.fullReview.includes(this.criteria5)) {
                this.fullReview = this.fullReview.concat(this.criteria5)
            }

            this.messageFree = this.messageGuided
            this.countFree = this.countGuided
        }
    }
};
</script>
